import {UIGameTimedAnimation} from './UIGameTimedAnimation'
import {PIXI} from '@colonist/pixi'
import {Point} from '@colonist/game-mechanic-validators'
import {TimeUtils} from '@colonist/utils'

interface ExpandContractAnimationOptions {
    center: Point
    maxSizeChangeRatio: number
    speedMultiplier: number
    originalSize: number
    currentSize: number
    frequency: number
}

export const SUGGEST_ACTION_ANIMATION_DURATION = 4000
const ALMOST_INFINITE_ANIMATION_DURATION = TimeUtils.SECONDS_IN_HOUR * TimeUtils.MILLISECONDS * 5

export class UIGameExpandContractAnimation extends UIGameTimedAnimation {
    protected readonly forceEnableAnimation: boolean = true
    protected readonly options: ExpandContractAnimationOptions

    constructor(viewToAnimate: PIXI.Container, animationDuration: number = ALMOST_INFINITE_ANIMATION_DURATION, options?: ExpandContractAnimationOptions) {
        super(animationDuration)
        this.viewToAnimate = viewToAnimate
        this.options = options ?? UIGameExpandContractAnimation.getDefaultOptions(viewToAnimate)
    }

    updateAnimation(deltaTime: number, elapsedMS: number): void {
        const {maxSizeChangeRatio, speedMultiplier, originalSize} = this.options
        const progress = this.totalElapsedMS / 1000
        const sizeChangePercentage = 1 + Math.sin(progress * speedMultiplier) * maxSizeChangeRatio
        this.setSize(originalSize * sizeChangePercentage)
    }

    resetToDefaultState(): void {
        this.setSize(this.options.originalSize)
        this.totalElapsedMS = 0
    }

    private setSize(size: number) {
        this.viewToAnimate.x = this.options.center.x - size / 2
        this.viewToAnimate.y = this.options.center.y - size / 2
        this.viewToAnimate.width = size
        this.viewToAnimate.height = size
    }

    private static getDefaultOptions(viewToAnimate: PIXI.Container): ExpandContractAnimationOptions {
        return {
            center: new Point(viewToAnimate.x + viewToAnimate.width / 2, viewToAnimate.y + viewToAnimate.height / 2),
            maxSizeChangeRatio: 0.1,
            speedMultiplier: 3.2,
            originalSize: viewToAnimate.width,
            currentSize: viewToAnimate.width,
            frequency: 1,
        }
    }
}
